import { useLocation } from "react-router-dom";

export const useRouteQueryParams = () => {
    const { search } = useLocation();

    return new URLSearchParams(search);
}
